import { useMePermissionByAccountApi } from 'api/alphaZulu/queries/useMePermissionByAccountApi'
import { skipEmptyParams } from 'api/common/utils'
import { useHubsApi } from 'api/hubs/queries/useHubsApi'
import { PageSize } from 'constants/pageSize'
import { Permission } from 'constants/permission'
import { useCurrentTenantData } from 'providers/currentTenantData/CurrentTenantDataContext'

export const useHubsWithAccessToFiles = ({ sortBy = '' }: { sortBy?: string } = {}) => {
  const { currentTenant } = useCurrentTenantData()
  const { isLoading: isHubsLoading, data: hubs } = useHubsApi(
    skipEmptyParams({
      params: {
        itemsPerPage: PageSize.All,
        tenantId: currentTenant.id,
        sort: sortBy,
      },
    }),
  )

  const accountIds = hubs?.map(({ azId }) => azId) || []

  const { data: permissionRecords, isLoading: isPermissionsLoading } = useMePermissionByAccountApi({
    params: { account_ids: accountIds },
    enabled: accountIds.length > 0,
  })

  const isLoading = isHubsLoading || isPermissionsLoading

  const canAccessAzIds = permissionRecords
    ?.map(({ account_id, permissions }) => ({
      account_id,
      canAccess: permissions?.includes(Permission.OS_FILE_MANAGER_ACCESS),
    }))
    .filter(({ canAccess }) => canAccess)
    .map(({ account_id }) => account_id)

  const hubsWithAccessToFiles = hubs?.filter(({ azId }) => canAccessAzIds?.includes(azId)) || []
  return {
    isLoading,
    hubsWithAccessToFiles,
  }
}
